<template>
    <div v-wechat-title="title">
        <crud-facecade
            ref="dic_narcoticsbox"
            :url="url"
            :tableHeight="tableHeight"
            :columns="columnList"
            :buttons="[]"
            :addButton="{ permission: 'default' }"
            :updateButton="{ permission: 'default' }"
            :deleteButton="{ enabled: true, permission: 'default' }"
        >
            <slot slot="filter">
                <el-col :md="6" :lg="4" :xl="3" class="padding-right10">
                    <item-input type="groupselect" v-model="dic_ward_id" :options="wardAuth" :clearable="true" placeholder="请选择区域"></item-input>
                </el-col>
            </slot>
        </crud-facecade>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `DicNarcoticsBox`,
    operation_room: ``,
    props: {

    },
    data() {
        return {
            title: `药箱维护`,
            dic_ward_id: undefined,
            url: { baseURL: `/api/AcisSystem/NarcoticsBox`,
                get: () => {
                    return this.loadNarcoticsBox()
                },
                post: (row) => {
                    return this.saveOne(row)
                },
                put: (row) => {
                    return new Promise((resolve, reject) => {
                        let req = this.myaxios.put(`/api/AcisSystem/NarcoticsBox/Put`, {
                            'id': row.id,
                            'name': row.name,
                            'code': row.code,
                            'description': row.description,
                            'is_deleted': row.is_deleted,
                            'regions': [{
                                'dic_operatingroom_id': row.dic_operating_room_id,
                                'room_name': row.dic_operating_room_name,
                                'sys_narcotics_box_id': row.id,
                                // "sys_supplies_template_id": 0,
                                'dic_operating_ward_id': _.startsWith(row.dic_ward_id, `ow_`) ? row.dic_ward_id.substr(3) : 0,
                                'dic_recovery_ward_id': _.startsWith(row.dic_ward_id, `rw_`) ? row.dic_ward_id.substr(3) : 0
                            }]
                        })
                        req.then(data => {
                            resolve(data)
                        }).catch(e => reject(e))
                    })
                } }
        }
    },
    created() {
        // this.$store.dispatch("ADD_WARD_AUTH")
    },
    computed: {
        ...mapGetters([`ward_auth`, `currentUser`, `recovery_ward_auth`, `operation_ward_auth_disabled`, `active_ward`, `screenHeight`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        wardAuth() {
            this.dic_ward_id = this.active_ward && this.active_ward.value
            return this.ward_auth
        },
        columnList() {
            return [{
                type: `string`,
                prop: `id`,
                label: `编号`,
                // width: "180",
                isListable: false,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                isKey: true
            }, {
                type: `number`,
                prop: `display_order`,
                label: `排序`,
                width: `180`,
                isListable: true,
                readonly: false,
                sortable: true,
                isDisplayOrder: true
            }, {
                type: `string`,
                prop: `code`,
                label: `编码`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: false,
                isCreatable: true,
                searchable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `string`,
                prop: `name`,
                label: `名称`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `string`,
                prop: `abbr`,
                label: `缩写`,
                width: `180`,
                isListable: false,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                searchable: false
            }, {
                type: `groupselect`,
                prop: `dic_ward_id`,
                label: `所属区域`,
                width: `120`,
                isListable: true,
                isEditable: true,
                isCreatable: true,
                colspan: 24,
                options: this.ward_auth,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            },
            {
                type: `string`,
                prop: `dic_operating_room_name`,
                label: `手术间`,
                width: `90`,
                isListable: true,
                default: true
            },
            // ACIS-23433 手术间毒麻药箱，增加'默认手术间
            {
                type: `select`,
                prop: `dic_operating_room_id`,
                label: `默认手术间`,
                isListable: false,
                isEditable: true,
                isCreatable: true,
                options: (that, { row }) => {
                    let r = _.filter(this.ward_auth, { value: row.dic_ward_id })
                    if (row.dic_ward_id == undefined) {
                        return []
                    } else {
                        // jira 1539 修改无意义变量名
                        // 2022-04-21 15:00, dongping.wang,ACIS-23433 手术间毒麻药箱，增加'默认手术间
                        let roomList = _.map(r[0].operation_room, d => {
                            return {
                                label: d.label,
                                value: d.value
                            }
                        })
                        return roomList
                    }
                },
                colspan: 20
            },
            {
                type: `textarea`,
                prop: `description`,
                label: `描述`,
                colspan: 24,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: false
            },
            {
                type: `rbool`,
                prop: `is_deleted`,
                label: `状态`,
                width: `70`,
                isListable: true,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                readonly: false,
                options: `is_enabled`,
                default: true
            }]
        }
    },
    methods: {
        loadNarcoticsBox() {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/NarcoticsBox/Get`)
                let that = this
                req.then(data => {
                    let groupId = _.groupBy(data, `id`)
                    let templates = []
                    _.forEach(groupId, (g) => {
                        let r = { ...g[0] }
                        let wards = g.map(d => { return (d.dic_operating_ward_id && `ow_${d.dic_operating_ward_id}`) || (d.dic_recovery_ward_id && `rw_${d.dic_recovery_ward_id}`) })
                        r.dic_ward_id = wards && wards[0]
                        if (that.dic_ward_id) {
                            if (r.dic_ward_id == that.dic_ward_id) {
                                templates.push(r)
                            }
                        } else {
                            templates.push(r)
                        }
                    })
                    resolve(templates)
                })
            })
        },
        ReloadListData() {
            let that = this
            that.$refs[`dic_narcoticsbox`].ReloadListData()
        },
        saveOne(row) {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.post(`/api/AcisSystem/NarcoticsBox/Post`, {
                    'name': row.name,
                    'code': row.code,
                    'description': row.description,
                    'is_deleted': row.is_deleted,
                    // "display_order":row.display_order,
                    'regions': [{
                        "dic_operatingroom_id": row.dic_operating_room_id,
                        'dic_operating_ward_id': _.startsWith(row.dic_ward_id, `ow_`) ? row.dic_ward_id.substr(3) : 0,
                        'dic_recovery_ward_id': _.startsWith(row.dic_ward_id, `rw_`) ? row.dic_ward_id.substr(3) : 0
                    }]
                })
                req.then(data => {
                    resolve(data)
                }).catch(e => reject(e))
            })
        }
    },
    watch: {
        dic_ward_id: function() {
            this.ReloadListData()
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/NarcoticsBox/Dic.vue